import { AdminFilterChips } from "@/components/admin";

const quickFilterChips = [
  { key: "all", label: "전체" },
  { key: "normal", label: "정상" },
  { key: "check-needed", label: "확인 필요" },
  { key: "no-response", label: "무응답" },
  { key: "offline-device", label: "기기 오프라인" },
  { key: "sound-check", label: "소리 확인" },
  { key: "emergency", label: "긴급 이벤트" },
];

interface QuickFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const QuickFilters = ({ activeFilter, onFilterChange }: QuickFiltersProps) => (
  <AdminFilterChips chips={quickFilterChips} activeKey={activeFilter} onChange={onFilterChange} />
);

export default QuickFilters;
